import React from 'react'

import { Footer, Header } from 'components/Layout/components'

import 'assets/sass/Page/error.scss'


const ErrorPage = (props) => (
	<div className="error-view ua-app login-page w-100 h-100">
		<Header
			isLoginPage={true}
			isDashboard={false}
			isMobile={false}
		/>

		<h1 className="error-title txt-bold text-center">{`優分析 UAnalyze－${props.isMaintaining ? '網站維護更新中...' : '404'}`}</h1>

		<div className="error-logo"/>

		<Footer/>
	</div>
)


export default ErrorPage
